import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { decryptToken } from "../utils/getToken";

const Joining = ({ prefillData, onClose }) => {
    const [selectedCandidate] = useState(prefillData);
    const [isJoining, setIsJoining] = useState("No");
    const [bonus, setBonus] = useState("");
    const [penalty, setPenalty] = useState("");
    const [documents, setDocuments] = useState({
        aadhar: null,
        education: null,
        pan: null,
        bank: null,
        experience: null,
        photo: null,
    });
    const apiUrl = API_BASE_URL;
    const [appointmentChecked, setAppointmentChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [joiningRecords, setJoiningRecords] = useState([]);
    const [alreadyJoined, setAlreadyJoined] = useState(false);
    const navigate = useNavigate()
    const token = decryptToken("accessToken") || ""

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setDocuments((prev) => ({ ...prev, [name]: files[0] }));
    };

    const fetchJoiningRecords = async () => {
        try {
            const res = await fetch(`${apiUrl}/joining`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await res.json();

            const filtered = data.filter(
                (record) => record.CandidateEmail === prefillData.CandidateEmail
            );
            setJoiningRecords(filtered);
        } catch (err) {
            console.error("Error fetching records:", err);
        }
    };

    useEffect(() => {
        fetchJoiningRecords();
    }, []);

    useEffect(() => {
        const joined = joiningRecords.some((record) => record.IsJoined === "Yes");
        setAlreadyJoined(joined);
    }, [joiningRecords]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isJoining === "Yes" && !appointmentChecked) {
            toast.info("Please confirm appointment letter");
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append("CandidateName", selectedCandidate.CandidateName);
        formData.append("CandidateEmail", selectedCandidate.CandidateEmail);
        formData.append("Role", selectedCandidate.Role);
        formData.append("AppointmentConfirmed", appointmentChecked ? "on" : "off");

        let joiningDate = selectedCandidate.JoiningDate;
        if (!joiningDate || isNaN(new Date(joiningDate).getTime())) {
            joiningDate = new Date().toISOString().split("T")[0];
        }
        formData.append("JoiningDate", joiningDate);
        formData.append("IsJoined", isJoining);

        if (isJoining === "Yes") {
            const pdfFileName = `appointment_${selectedCandidate.CandidateEmail.replace(/[@.]/g, "_")}_${Date.now()}.pdf`;
            formData.append("pdfFileName", pdfFileName);
            navigate("/new-staff");
        } else {
            onClose();
        }
        const res = await fetch(`${apiUrl}/joining`, {
            method: "POST",
            body: formData,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });

        if (res.ok) {
            toast.success("Joining details submitted successfully!");
            setIsJoining("No");
            setDocuments({
                aadhar: null,
                education: null,
                pan: null,
                bank: null,
                experience: null,
                photo: null,
            });
            setAppointmentChecked(false);
            fetchJoiningRecords();
            onClose();
        } else {
            toast.error("Submission failed.");
        }

        setLoading(false);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-[99999] flex flex-col justify-end items-center">
            <div className="bg-white w-full max-h-[90vh] max-w-[600px] rounded-t-2xl shadow-xl p-5 overflow-y-auto transition-transform duration-300 animate-slide-up">
                <h2 className="text-lg font-semibold text-gray-800">
                    Joining Confirmation
                </h2>

                <form
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"
                    className="space-y-3 text-sm"
                >
                    <div className="space-y-1">
                        <p><span className="font-medium">Name:</span> {selectedCandidate.CandidateName}</p>
                        <p><span className="font-medium">Email:</span> {selectedCandidate.CandidateEmail}</p>
                        <p><span className="font-medium">Role:</span> {selectedCandidate.Role}</p>
                        <p><span className="font-medium">Joining Date:</span>{" "}
                            {selectedCandidate.JoiningDate && !isNaN(new Date(selectedCandidate.JoiningDate))
                                ? new Date(selectedCandidate.JoiningDate).toLocaleDateString()
                                : new Date().toLocaleDateString()}
                        </p>
                    </div>

                    <div>
                        <label className="block font-medium mb-1">Did the candidate join?</label>
                        <select
                            value={isJoining}
                            onChange={(e) => setIsJoining(e.target.value)}
                            required
                            className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                        >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                        </select>
                    </div>

                    {isJoining === "Yes" && (
                        <div className="space-y-4">
                            {/* <div>
                                <label className="block font-medium mb-1">Bonus (if any)</label>
                                <input
                                    type="text"
                                    name="bonus"
                                    placeholder="Enter Bonus Amount or Note"
                                    value={bonus}
                                    onChange={(e) => setBonus(e.target.value)}
                                    className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                                />
                            </div>

                            <div>
                                <label className="block font-medium mb-1">Penalty (if any)</label>
                                <input
                                    type="text"
                                    name="penalty"
                                    placeholder="Enter Penalty Amount or Note"
                                    value={penalty}
                                    onChange={(e) => setPenalty(e.target.value)}
                                    className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                                />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {["aadhar", "education", "pan", "bank", "experience", "photo"].map((doc) => (
                                    <div key={doc}>
                                        <label className="block font-medium mb-1 capitalize">
                                            Upload {doc}
                                        </label>
                                        <input
                                            type="file"
                                            name={doc}
                                            accept={doc === "photo" ? "image/*" : "application/pdf,image/*"}
                                            onChange={handleFileChange}
                                            className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                                        />
                                    </div>
                                ))}
                            </div> */}

                            <div className="flex justify-center py-5">
                                <button
                                    onClick={() =>
                                        navigate("/new-staff", {
                                            state: {
                                                firstName: selectedCandidate.CandidateName.split(" ")[0] || "",
                                                lastName: selectedCandidate.CandidateName.split(" ")[1] || "",
                                                email: selectedCandidate.CandidateEmail,
                                                job_title: selectedCandidate.Role,
                                                dof_joining:
                                                    selectedCandidate.JoiningDate || new Date().toISOString().split("T")[0],

                                                // 🔥 Offer letter ke fields
                                                salary: selectedCandidate.Salary,
                                                report_manager: selectedCandidate.ReportingManager || "",
                                                start_time: selectedCandidate.StartTime
                                                    ? selectedCandidate.StartTime.slice(0, 5) // "09:30:00" → "09:30"
                                                    : "",
                                                end_time: selectedCandidate.EndTime
                                                    ? selectedCandidate.EndTime.slice(0, 5)
                                                    : "",
                                                employmentType: selectedCandidate.NatureofEmployment,
                                                probationPeriod: selectedCandidate.ProbationPeriod,
                                                address: selectedCandidate.Address,
                                            },
                                        })

                                    }

                                    className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm disabled:bg-blue-300 disabled:cursor-not-allowed"
                                >
                                    Add Employee Details
                                </button>
                            </div>

                            <label className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    name="AppointmentConfirmed"
                                    checked={appointmentChecked}
                                    onChange={(e) => setAppointmentChecked(e.target.checked)}
                                    className="h-4 w-4"
                                />
                                <span className="text-sm">Confirm Appointment Letter</span>
                            </label>
                        </div>
                    )}

                    <div className="flex justify-end gap-3 pt-2 mt-5">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading || alreadyJoined}
                            className={`px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm disabled:bg-blue-300 disabled:cursor-not-allowed ${alreadyJoined
                                ? "bg-gray-400 cursor-not-allowed"
                                : loading
                                    ? "bg-blue-200 text-white cursor-not-allowed"
                                    : "bg-blue-600 hover:bg-blue-700 text-white"
                                }`}
                        >
                            {alreadyJoined ? "Already Joined" : loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </form>

                {/* Candidate’s Joining Record */}
                <h3 className="text-xl font-semibold mt-8 mb-2 text-gray-800">
                    This Candidate’s Joining Record
                </h3>
                {joiningRecords.length > 0 ? (
                    <table className="w-full border border-gray-300 text-sm rounded-lg overflow-hidden">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="border px-3 py-2 text-left">Name</th>
                                <th className="border px-3 py-2 text-left">Email</th>
                                <th className="border px-3 py-2 text-left">Role</th>
                                <th className="border px-3 py-2 text-left">Joining Date</th>
                                <th className="border px-3 py-2 text-left">Joined?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {joiningRecords.map((record, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="border px-3 py-2">{record.CandidateName}</td>
                                    <td className="border px-3 py-2">{record.CandidateEmail}</td>
                                    <td className="border px-3 py-2">{record.Role}</td>
                                    <td className="border px-3 py-2">
                                        {new Date(record.JoiningDate).toLocaleDateString()}
                                    </td>
                                    <td className="border px-3 py-2">{record.IsJoined}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="text-gray-500 text-sm">No joining record for this candidate.</p>
                )}
            </div>
        </div>
    );
};

export default Joining;
